// Container.tsx
import { useEffect, useState } from "react";
import { FileUpload, wizardStepType } from "../../type";
import { BrowserFile } from "./steps/browserFile";
import { FunctionMap } from "./steps/functionMap";
import { useApp } from "../../../../components/app";
import { ColumnsMap } from "./steps/columnsMap";
import Swal from "sweetalert2";
import ReviewAndUpload from "./steps/reviewAndUpload";

const Container = (props: any) => {
  const {
    app,
    currentStep,
    resetId,
    fileUpload,
    onFileUpdate,
    refresh,
    FileUploadRefresh,
    onFileUpdateRefresh,
    api,
    closeAddUpdate,
    isUpdate,
    selectedFunction,
    columnMappingData,
    setColumnMappingData,
    dateValidationResults, // NEW
    setDateValidationResults, // NEW
    stableDateFormat
  } = props;
  const [selectedMap, setSelectedMap] = useState(null);

  return (
    <div className="wizard-container">
      {currentStep === wizardStepType.BrowserFile && (
        <BrowserFile fileUpload={fileUpload} onFileUpdate={onFileUpdate} onFileUpdateRefresh={onFileUpdateRefresh} />
      )}
      {currentStep === wizardStepType.FunctionMap && (
        <FunctionMap
          fileUpload={fileUpload}
          onFileUpdate={onFileUpdate}
          refresh={refresh}
          selectedFunction={selectedFunction}
          app={app}
        />
      )}
      {currentStep === wizardStepType.ColumnsMap && (
        <ColumnsMap
          fileUpload={fileUpload}
          onFileUpdate={onFileUpdate}
          refresh={refresh}
          resetId={resetId}
          app={app}
          selectedMap={selectedMap}
          setColumnMappingData={setColumnMappingData}
          setSelectedMap={setSelectedMap}
          dateValidationResults={dateValidationResults} // NEW: Forward
          setDateValidationResults={setDateValidationResults} // NEW: Forward
          stableDateFormat={stableDateFormat}
        />
      )}
      {currentStep === wizardStepType.ReviewAndUpload && (
        <ReviewAndUpload
          fileUpload={fileUpload}
          app={app}
          api={api}
          isUpdate={isUpdate}
          selectedFunction={selectedFunction}
          closeAddUpdate={closeAddUpdate}
          columnMappingData={columnMappingData}
        />
      )}
    </div>
  );
};
export { Container };